// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"67":"7b62e8a2","483":"d3bb1960","587":"2ad5ba22","888":"2ea03839"}[chunkId] + ".chunk.css";
};